import { Tag } from '../Tag';
import { ResolveValue } from '../ResolveValue';

function createResolver(context) {
  return {
    isTag: function isTag(arg) {
      if (!(arg instanceof Tag)) {
        return false;
      }

      for (var _len = arguments.length, types = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        types[_key - 1] = arguments[_key];
      }

      if (types.length) {
        return types.reduce(function (isType, type) {
          return isType || type === arg.type;
        }, false);
      }

      return true;
    },
    isCompute: function isCompute(arg) {
      console.warn('[DEPRECATION] Do not use this anymore, use "isResolveValue" which now returns true for both Tag and Compute.');
      return arg instanceof ResolveValue && !(arg instanceof Tag);
    },
    isResolveValue: function isResolveValue(arg) {
      return arg instanceof ResolveValue;
    },
    value: function value(arg) {
      var overrides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (arg instanceof ResolveValue) {
        return arg.getValue(overrides ? Object.assign({}, context, overrides) : context);
      }

      return arg;
    },
    path: function path(arg) {
      if (arg instanceof Tag) {
        return arg.getPath(context);
      }

      throw new Error('You are extracting a path from an argument that is not a Tag.');
    }
  };
}

function ResolveProviderFactory() {
  function ResolveProvider(context) {
    context.resolve = createResolver(context);
    return context;
  }

  return ResolveProvider;
}

export default ResolveProviderFactory;